import type { Category } from '@/mocks/archive';

export type ToneRole = 'primary' | 'accent' | 'secondary';

export interface ToneClasses {
  chip: string;
  chipDot: string;
  solid: string;
  soft: string;
  text: string;
  border: string;
}

export const tone: Record<ToneRole, ToneClasses> = {
  primary: {
    chip: 'bg-primary-100 text-primary-800',
    chipDot: 'bg-primary-500',
    solid: 'bg-primary-500 text-background-50 hover:bg-primary-600',
    soft: 'bg-primary-50 text-primary-700 border border-primary-100',
    text: 'text-primary-600',
    border: 'border-primary-200',
  },
  accent: {
    chip: 'bg-accent-100 text-accent-800',
    chipDot: 'bg-accent-500',
    solid: 'bg-accent-500 text-background-50 hover:bg-accent-600',
    soft: 'bg-accent-50 text-accent-700 border border-accent-100',
    text: 'text-accent-600',
    border: 'border-accent-200',
  },
  secondary: {
    chip: 'bg-secondary-100 text-secondary-800',
    chipDot: 'bg-secondary-500',
    solid: 'bg-secondary-500 text-background-50 hover:bg-secondary-600',
    soft: 'bg-secondary-50 text-secondary-700 border border-secondary-100',
    text: 'text-secondary-600',
    border: 'border-secondary-200',
  },
};

export function categoryOf(slug: string): Category | undefined {
  // categories are imported in page modules to avoid circular import
  return undefined;
}

export function formatViews(n: number): string {
  if (n >= 100000000) return `${(n / 100000000).toFixed(1)}亿`;
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return `${n}`;
}

export function readDate(date: string): string {
  return date;
}